module.exports = __webpack_public_path__ + "static/assets/3f9f646b65993156d6445b658de56d3a.png";